import React from 'react';
export const Transformation = () => {
  return <section className="text-lg md:text-xl text-gray-800 mb-12 leading-relaxed space-y-6" data-id="element-187" data-mp="oqyc07sj7uas">
      <h2 className="font-bold text-2xl md:text-3xl mt-12 mb-6 text-gray-900" data-id="element-188" data-mp="ikszq0c37ktm">
        Imagine Tomorrow Morning
      </h2>

      <figure className="my-8 float-right w-full md:w-1/2 md:ml-6 mb-6" data-id="element-189" data-mp="moh64fozgada">
        <img src="https://cdn.magicpatterns.com/uploads/hqJmtEigVRFjcLAzuf5qmx/Couple_Sleeping.jpg" alt="Peaceful Sleep" className="w-full rounded-sm shadow-sm m-0" data-id="element-190" data-mp="rmioszihy7o8" />
      </figure>

      <p data-id="element-191" data-mp="11h28q984tl6r">You wake up.</p>
      <p data-id="element-192" data-mp="16adfkacy21yo">Open your eyes.</p>
      <p data-id="element-193" data-mp="16b6kd5scehe6">Turn your head.</p>
      <p data-id="element-194" data-mp="16awzfwm5n0fc">
        And instead of immediately searching for relief... You simply start your
        day.
      </p>

      <p data-id="element-195" data-mp="1adjndmfpg179">
        No stretching routine. No discomfort dominating your morning. No
        wondering what you did wrong while sleeping.
      </p>

      <p data-id="element-196" data-mp="1kay29hlzchxg">
        <strong data-id="element-197" data-mp="1kaoapplae2pn">Just a better start.</strong>
      </p>

      <blockquote className="border-l-4 border-blue-500 pl-6 italic text-gray-600 my-8 text-xl clear-both" data-id="element-198" data-mp="1c60c494obtye">
        "The biggest difference wasn't sleeping better. It was finally waking up
        feeling normal again."
      </blockquote>
    </section>;
};